export const categories = [
  {
    id: 'timeline',
    name: '事件复盘',
    icon: 'ri-timeline-view',
    desc: '按时间线还原一个热点从起势、发酵到收场的关键节点，先看顺序再看结论。',
  },
  {
    id: 'opinion',
    name: '舆论观察',
    icon: 'ri-chat-poll-line',
    desc: '观察话题如何升温、转向与降温，理解情绪曲线背后真正推动它变化的东西。',
  },
  {
    id: 'industry',
    name: '行业生态',
    icon: 'ri-building-2-line',
    desc: '宣发节奏、公关话术、代言合同、后援会运作，把台前的瓜拆成幕后的流程。',
  },
  {
    id: 'method',
    name: '理性吃瓜',
    icon: 'ri-shield-check-line',
    desc: '一套可复用的信息核对清单，帮你区分实锤、旧图和被人为拼接的物料。',
  },
  {
    id: 'archive',
    name: '旧帖考古',
    icon: 'ri-history-line',
    desc: '翻看公开历史发言与作品的时间线变化，用完整语境替代单张截屏。',
  },
];

export default categories;